export default __webpack_public_path__ + "static/media/glitch32.8877674b.png";